import request from '@/utils/request'

// 查询用户账户流水分页
export function pageAccountBill(query) {
  return request({
    url: '/user/bill/page',
    method: 'get',
    params: query
  })
}

// 查询用户账户流水列表
export function listAccountBill(query) {
  return request({
    url: '/user/bill/list',
    method: 'get',
    params: query
  })
}

// 查询用户账户流水详细
export function getAccountBill(data) {
  return request({
    url: '/user/bill/detail',
    method: 'get',
    params: data
  })
}

// 新增用户账户流水
export function addAccountBill(data) {
  return request({
    url: '/user/bill/add',
    method: 'post',
    data: data
  })
}

// 修改用户账户流水
export function updateAccountBill(data) {
  return request({
    url: '/user/bill/edit',
    method: 'post',
    data: data
  })
}

// 删除用户账户流水
export function delAccountBill(data) {
  return request({
    url: '/user/bill/delete',
    method: 'post',
    data: data
  })
}

// 导出用户账户流水列表
export function exportAccountBill(data) {
  return request({
    url: '/user/bill/export',
    method: 'post',
    data: data,
    responseType: 'blob'
  })
}
